export default __webpack_public_path__ + "static/notebooks-cross-program-e1ca99b5bc6f26e096a2b4a934e23b24.png";